// @ts-nocheck

/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetCurrentUserUsersMeGetQueryResponse } from "../models/usersController/GetCurrentUserUsersMeGet.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";
import type {
  QueryKey,
  QueryClient,
  UseQueryOptions,
  UseQueryReturnType,
} from "@tanstack/vue-query";
import { getCurrentUserUsersMeGet } from "../client/getCurrentUserUsersMeGet.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const getCurrentUserUsersMeGetQueryKey = () =>
  [{ url: "/users/me" }] as const;

export type GetCurrentUserUsersMeGetQueryKey = ReturnType<
  typeof getCurrentUserUsersMeGetQueryKey
>;

export function getCurrentUserUsersMeGetQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getCurrentUserUsersMeGetQueryKey();
  return queryOptions<
    GetCurrentUserUsersMeGetQueryResponse,
    ResponseErrorConfig<Error>,
    GetCurrentUserUsersMeGetQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getCurrentUserUsersMeGet({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Get current authenticated user profile.
 * @summary Get Current User
 * {@link /users/me}
 */
export function useGetCurrentUserUsersMeGet<
  TData = GetCurrentUserUsersMeGetQueryResponse,
  TQueryData = GetCurrentUserUsersMeGetQueryResponse,
  TQueryKey extends QueryKey = GetCurrentUserUsersMeGetQueryKey,
>(
  options: {
    query?: Partial<
      UseQueryOptions<
        GetCurrentUserUsersMeGetQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    (resolvedOptions && "queryKey" in resolvedOptions
      ? toValue(resolvedOptions.queryKey)
      : undefined) ?? getCurrentUserUsersMeGetQueryKey();

  const query = useQuery(
    {
      ...getCurrentUserUsersMeGetQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as UseQueryOptions<
      GetCurrentUserUsersMeGetQueryResponse,
      ResponseErrorConfig<Error>,
      TData,
      GetCurrentUserUsersMeGetQueryResponse,
      TQueryKey
    >,
    toValue(queryClient),
  ) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
